export const surfaceSx = {
  backgroundColor: 'surface',
  border: '1px solid',
  borderColor: 'border',
  borderRadius: '0.5rem',
  boxShadow: 1,
} as const;

export const interactiveSurfaceSx = {
  ...surfaceSx,
  transition: 'box-shadow 150ms ease, border-color 150ms ease, background-color 150ms ease',
  '@media (hover: hover)': {
    '&:hover': { boxShadow: 4 },
  },
} as const;
